import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalDay: 0,
    percentTotal: 0
};

export const useAlertN3Store = create((set) => ({

    ...initialState,

    setAlertN3: ({
        data,
        total,
        totalDay,
        percentTotal
    }) => {

        set({
            data,
            total,
            totalDay,
            percentTotal
        });

    },

    clearAlertN3: () => {
        set(initialState);
    }

}));